/* eslint-disable dxp-rules/no-inline-css -- width/height are dynamic layout props */
import type { CSSProperties, FC } from 'react';

import { roundedSkeleton } from './RoundedSkeleton.css';

export interface RoundedSkeletonProps {
  width?: CSSProperties['width'];
  height?: CSSProperties['height'];
  style?: CSSProperties;
  className?: string;
}

export const RoundedSkeleton: FC<RoundedSkeletonProps> = ({ height, width, style: inlineStyle, className }) => {
  return (
    <div
      className={[roundedSkeleton, className].filter(Boolean).join(' ')}
      style={{ height, width, ...inlineStyle }}
    />
  );
};
